import { AlertTriangle, Trash2 } from "lucide-react";
import Modal from "./Modal";

/**
 * Reusable destructive-action confirmation modal.
 *
 * Usage:
 *   <ConfirmModal
 *     open={!!toDelete}
 *     onClose={() => setToDelete(null)}
 *     onConfirm={() => doDelete(toDelete)}
 *     title="Delete site"
 *     message={<>Permanently delete site <b>{toDelete?.name}</b>?</>}
 *   />
 */
export default function ConfirmModal({
  open,
  onClose,
  onConfirm,
  title = "Confirm delete",
  message = "Are you sure?",
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  testId = "confirm-modal",
  busy = false,
  variant = "danger",
}) {
  if (!open) return null;
  const danger = variant === "danger";
  return (
    <Modal open onClose={onClose} title={title} testId={testId} maxWidth="max-w-md">
      <div className="space-y-4">
        <div className="flex items-start gap-3">
          <div
            className={`w-10 h-10 rounded-md flex items-center justify-center border ${
              danger
                ? "border-rose-500/40 bg-rose-500/10 text-rose-300"
                : "border-amber-500/40 bg-amber-500/10 text-amber-300"
            }`}
          >
            <AlertTriangle className="w-5 h-5" />
          </div>
          <div className="text-sm text-[#dde3ec] leading-relaxed flex-1">{message}</div>
        </div>
        <div className="flex justify-end gap-2 pt-2 border-t border-white/5">
          <button
            type="button"
            onClick={onClose}
            disabled={busy}
            className="hv-btn hv-btn-ghost"
            data-testid={`${testId}-cancel`}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={busy}
            className={`hv-btn ${danger ? "hv-btn-danger" : "hv-btn-primary"}`}
            data-testid={`${testId}-confirm`}
          >
            <Trash2 className="w-4 h-4" /> {busy ? "Working…" : confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
}
